import SubscriptionReport from "@adapters/presenters/Reports/SubscriptionFee";
export default (useCases, actions) => {
    return {
        subscriptionReport: new SubscriptionReport(useCases, actions, useCases.sendEmailReports, useCases.downloadPDFReports, useCases.downloadExcelReports),
    };
};
